/**
 * Dreams Setup - Hero Sparks Effect
 * Developed for Ahmad Hajjaj
 */

(function() {
  const canvas = document.getElementById('spark-bg');
  if (!canvas) return; // تأكد من وجود الكانفاس لتجنب الأخطاء

  const ctx = canvas.getContext('2d');
  const header = canvas.parentElement;

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = header.offsetHeight;
  }
  
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  const sparks = []; 
  const trailSparks = []; 
  const SPARK_COUNT = 80;

  class Spark {
    constructor(isTrail = false, x = 0, y = 0) {
      this.isTrail = isTrail;
      if (isTrail) {
        this.initTrail(x, y);
      } else {
        this.init(true);
      }
    }

    init(randomY = false) {
      this.x = Math.random() * canvas.width;
      this.y = randomY ? Math.random() * canvas.height : canvas.height + 20;
      this.w = Math.random() * 1.5 + 1;
      this.h = Math.random() * 5 + 2;
      this.dy = -(Math.random() * 0.4 + 0.2); 
      this.dx = 0;
      this.alpha = Math.random() * 0.5 + 0.2;
      this.fadeRate = Math.random() * 0.001 + 0.0005;
      this.time = Math.random() * 100;
      this.freedom = Math.random() * 0.6 + 0.2;
      this.hasGlow = Math.random() > 0.7;
    }

    initTrail(x, y) {
      this.x = x;
      this.y = y;
      this.w = Math.random() * 2 + 1;
      this.h = this.w;
      this.dx = (Math.random() - 0.5) * 4;
      this.dy = (Math.random() - 0.5) * 4;
      this.alpha = 1; 
      this.fadeRate = 0.02; 
      this.hasGlow = true; 
    }

    draw() {
      ctx.save();
      ctx.translate(this.x, this.y);
      if (this.hasGlow) {
        ctx.shadowBlur = 10;
        ctx.shadowColor = "rgba(204, 0, 14, 0.8)";
      }
      ctx.beginPath();
      ctx.fillStyle = `rgba(204, 0, 14, ${this.alpha})`;
      ctx.fillRect(-this.w/2, -this.h/2, this.w, this.h);
      ctx.restore();
    }

    update() {
      this.x += this.dx;
      this.y += this.dy;

      if (!this.isTrail) {
        this.time += 0.02;
        this.x += Math.sin(this.time) * this.freedom;
      }

      this.alpha -= this.fadeRate;
    }
  }

  for (let i = 0; i < SPARK_COUNT; i++) {
    sparks.push(new Spark());
  }

  const createTrail = (x, y) => {
    for(let i=0; i<3; i++) {
      trailSparks.push(new Spark(true, x, y));
    }
  };

  header.addEventListener('mousemove', (e) => {
    const rect = header.getBoundingClientRect();
    createTrail(e.clientX - rect.left, e.clientY - rect.top);
  });

  header.addEventListener('touchmove', (e) => {
    if (e.cancelable) e.preventDefault();
    const rect = header.getBoundingClientRect();
    const touch = e.touches[0];
    createTrail(touch.clientX - rect.left, touch.clientY - rect.top);
  }, { passive: false });

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    sparks.forEach(s => {
      s.update();
      if (s.alpha <= 0 || s.y < -20) s.init(false);
      s.draw();
    });

    for (let i = trailSparks.length - 1; i >= 0; i--) {
      let ts = trailSparks[i];
      ts.update();
      ts.draw();
      if (ts.alpha <= 0) {
        trailSparks.splice(i, 1);
      }
    }

    requestAnimationFrame(animate);
  }

  animate();
})();